import React, { useEffect, useRef, useState } from "react";

// Gold dot cursor that expands and shows a label over interactive/marked elements
export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [label, setLabel] = useState("");
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;
    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ringPos = { ...pos };
    let raf;

    const move = (e) => {
      pos.x = e.clientX; pos.y = e.clientY;
      if (dot.current) dot.current.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      const el = e.target.closest("[data-cursor], a, button, input, textarea, [role=button]");
      if (el) {
        setActive(true);
        setLabel(el.getAttribute("data-cursor") || "");
      } else {
        setActive(false);
        setLabel("");
      }
    };
    const loop = () => {
      ringPos.x += (pos.x - ringPos.x) * 0.18;
      ringPos.y += (pos.y - ringPos.y) * 0.18;
      if (ring.current) ring.current.style.transform = `translate(${ringPos.x}px, ${ringPos.y}px)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("pointermove", move);
    raf = requestAnimationFrame(loop);
    return () => { window.removeEventListener("pointermove", move); cancelAnimationFrame(raf); };
  }, []);

  return (
    <div className="hidden md:block" aria-hidden data-testid="custom-cursor">
      <div ref={dot} className="fixed top-0 left-0 z-[9999] pointer-events-none -ml-[3px] -mt-[3px]">
        <div className="w-1.5 h-1.5 rounded-full bg-[var(--gold-bright)]" />
      </div>
      <div ref={ring} className="fixed top-0 left-0 z-[9998] pointer-events-none">
        <div
          className="rounded-full border border-[var(--gold)] flex items-center justify-center transition-all duration-300"
          style={{
            width: active ? (label ? 76 : 44) : 30,
            height: active ? (label ? 76 : 44) : 30,
            marginLeft: active ? (label ? -38 : -22) : -15,
            marginTop: active ? (label ? -38 : -22) : -15,
            background: active ? "rgba(197,160,89,0.08)" : "transparent",
            backdropFilter: active ? "blur(2px)" : "none",
          }}
        >
          {label && <span className="text-[9px] tracking-[0.2em] uppercase text-[var(--gold)]">{label}</span>}
        </div>
      </div>
    </div>
  );
}
